<template>
  <div class="company" :style="{'height': height 
		+ 'px'}">
    <p>This website is owned by FILAMEDIA CO., LIMITED.</p>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      height: null
    };
  },
  mounted() {
    const headerHeight = document.getElementsByClassName('header-box')[0].clientHeight;
    const footerHeight = document.getElementById('plex-footer').clientHeight;
    this.height = window.innerHeight - headerHeight - footerHeight;
  }
};
</script>

<style lang="scss" scoped>
.company {
  position: relative;
  background: #151429;
  p {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    margin-bottom: 0;
    color: #FFF;
  }
}
</style>


// WEBPACK FOOTER //
// company.vue?24fe7bae